<template>
  <v-row no-gutters>
    <v-col>
      <v-card :style="{ height: blockFormHeight + 'px', 'overflow-y': 'auto' }">
        <v-card-title class="pb-0">
          <h1 class="headline font-weight-medium">
            {{ header }}
          </h1>
          <v-spacer />
          <ActionsModalWindow
            v-if="modal"
            :id="id"
            component-name="Client"
            @close="$emit('close')"
          />
        </v-card-title>
        <v-card-text class="py-0">
          <v-row no-gutters>
            <v-col>
              <v-row>
                <v-col class="pb-0 mb-n3">
                  <CustomTextField
                    v-model="title"
                    label="Найменування*"
                    :error-messages="$v.title.$error ? errors.TITLE : []"
                    :hide-details="false"
                    @input="$v.title.$touch()"
                  />
                </v-col>
                <v-col class="pb-0 mb-n3">
                  <CustomTextField
                    v-model="crm"
                    label="Посилання на CRM*"
                    append-icon="search"
                    :error-messages="$v.crm.$error ? errors.CRM : []"
                    :hide-details="false"
                    @click:append="redirectCRM(crm)"
                    @input="$v.crm.$touch()"
                  />
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col>
                  <v-tabs
                    v-model="tab"
                    slider-color="red lighten-2"
                  >
                    <v-tab>Основна інформація</v-tab>
                    <v-tab>Сервіси ({{ services.length }})</v-tab>
                    <v-tab>Продукти ({{ products.length }})</v-tab>
                    <v-tab>Оплати</v-tab>
                    <v-tab>Специфікації</v-tab>
                    <v-tabs-items
                      v-model="tab"
                      :style="{
                        height: blockTabHeight + 'px',
                        'overflow-y': 'auto',
                      }"
                    >
                      <v-tab-item>
                        <v-card
                          text
                          flat
                        >
                          <v-card-text>
                            <v-row dense>
                              <v-col>
                                <ManagerSelect v-model="manager" />
                              </v-col>
                              <v-col>
                                <EmployeeSelect
                                  v-model="analyst"
                                  label="Відповідальний Аналітик / Керівник проекту"
                                  placeholder="Введіть iм’я відповідального аналітика або керівника проекту"
                                  :hide-details="false"
                                />
                              </v-col>
                            </v-row>

                            <v-row
                              dense
                              class="mt-n2"
                            >
                              <v-col cols="2">
                                <v-switch
                                  v-model="partnershipStopped"
                                  label="Співпрацю призупинено"
                                  class="mx-1 mb-n4"
                                  color="green"
                                  dense
                                  :error-messages="
                                    $v.partnershipStopped.$error
                                      ? errors.PARTNERSHIP_STOPPED
                                      : []
                                  "
                                  :hide-details="false"
                                  @change="$v.partnershipStopped.$touch()"
                                />
                              </v-col>
                              <v-col cols="4">
                                <DatePicker
                                  v-model="partnershipStoppedDate"
                                  default-value
                                  :filled="false"
                                  :disabled="!partnershipStopped"
                                  :required="partnershipStopped"
                                  :error-messages="
                                    $v.partnershipStoppedDate.$invalid
                                      ? errors.PARTNERSHIP_STOPPED_DATE
                                      : []
                                  "
                                  :hide-details="false"
                                  @change="$v.partnershipStoppedDate.$touch()"
                                />
                              </v-col>
                              <v-col cols="6">
                                <CustomTextField
                                  v-model="partnershipStoppedReason"
                                  label="Причина припинення співпраці"
                                  :disabled="!partnershipStopped"
                                  placeholder="Введіть причину"
                                  :required="partnershipStopped"
                                  :hide-details="false"
                                  :error-messages="
                                    $v.partnershipStoppedReason.$error
                                      ? errors.PARTNERSHIP_STOPPED_REASON
                                      : []
                                  "
                                  @input="$v.partnershipStoppedReason.$touch()"
                                />
                              </v-col>
                            </v-row>
                            <v-row class="mt-n4">
                              <v-col class="pb-0">
                                <ClientProjects
                                  :client-id="id"
                                  :projects="projects"
                                  :is-new="isNew"
                                  @add="addProject"
                                />
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col class="pt-0 pb-0">
                                <GoogleDrive v-model="googleDriveFolders" />
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col>
                                <v-textarea
                                  v-model="comments"
                                  label="Примітки"
                                  class="ma-1 pt-2"
                                  outlined
                                  dense
                                />
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-tab-item>
                      <v-tab-item>
                        <v-col>
                          <v-card flat>
                            <v-card-text>
                              <ClientServices v-model="services" />
                            </v-card-text>
                          </v-card>
                        </v-col>
                      </v-tab-item>
                      <v-tab-item>
                        <v-card
                          text
                          flat
                        >
                          <v-card-text>
                            <v-row>
                              <v-col class="mx-4">
                                <v-row
                                  class="mb-2"
                                  align="center"
                                >
                                  <v-icon
                                    class="mr-1"
                                    medium
                                    color="yellow"
                                  >
                                    https
                                  </v-icon>
                                  <h3 class="font-weight-medium">
                                    Кабінет з оновленнями
                                  </h3>
                                </v-row>
                                <v-row>
                                  <v-icon class="mr-3">
                                    link
                                  </v-icon>
                                  <DescriptionLink
                                    v-model="url"
                                    label="Url"
                                    class="mr-3"
                                    text="Немає посилання"
                                    style="max-width: 175px"
                                    :text-truncate="true"
                                  />
                                  <CustomTextField
                                    v-model="updatesCabinetAccess.login"
                                    label="Логін"
                                    :hide-details="true"
                                    class="mr-3"
                                  />
                                  <CustomTextField
                                    v-model="updatesCabinetAccess.password"
                                    label="Пароль"
                                    :hide-details="true"
                                    class="mr-3"
                                  />
                                  <CustomTextField
                                    v-model="email"
                                    label="Email"
                                    :hide-details="true"
                                    class="mr-3"
                                  />
                                </v-row>
                              </v-col>
                            </v-row>
                            <ClientProducts
                              v-model="products"
                              :client-id="id"
                            />
                          </v-card-text>
                        </v-card>
                      </v-tab-item>
                      <v-tab-item>
                        <v-card
                          text
                          flat
                        >
                          <v-card-text>
                            <ClientPayers
                              :height="44"
                              class="ma-1"
                              @input="addPayer"
                            />
                            <ClientPayments :id="id" />
                          </v-card-text>
                        </v-card>
                      </v-tab-item>
                      <v-tab-item>
                        <v-card
                          text
                          flat
                        >
                          <v-card-text>
                            <ClientSpecifications :id="id" />
                          </v-card-text>
                        </v-card>
                      </v-tab-item>
                    </v-tabs-items>
                  </v-tabs>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions
          v-if="!modal"
          class="pl-3 mt-3"
        >
          <PrimaryBtn
            :has-warnings="$v.$invalid"
            :loading="loading"
            @click="save"
          />
          <v-btn @click="$router.go(-1)">
            Відмінити
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import ManagerSelect from "../managers/ManagerSelect.vue";
import EmployeeSelect from "../employees/EmployeeSelect.vue";
import ClientPayers from "./ClientPayers.vue";
import ClientProjects from "./ClientProjects.vue";
import ClientPayments from "./ClientPayments.vue";
import ClientServices from "./Services/ClientServices.vue";
import ClientProducts from "./Products/ClientProducts.vue";
import DatePicker from "@/components/story/DatePicker";
import GoogleDrive from "./GoogleDrive.vue";
import PrimaryBtn from "@/components/PrimaryBtn.vue";
import DescriptionLink from "@/components/DescriptionLink";
import ClientSpecifications from "./ClientSpecifications.vue";

import * as clientsApi from "@/backend/clientsApi.js";

import { ERRORS, fetchInParallel } from "@/helpers";
import { required, minLength, requiredIf } from "vuelidate/lib/validators";

export default {
  components: {
    ManagerSelect,
    EmployeeSelect,
    ClientPayers,
    ClientProjects,
    ClientPayments,
    ClientServices,
    ClientProducts,
    DatePicker,
    GoogleDrive,
    PrimaryBtn,
    DescriptionLink,
    ClientSpecifications,
    ActionsModalWindow() {
      return import("@/components/ActionsModalWindow.vue");
    },
  },
  props: ["id", "modal"],
  data: () => ({
    title: "",
    projects: [],
    services: [],
    products: [],
    manager: null,
    analyst: null,
    updatesCabinetAccess: {},
    partnershipStopped: false,
    comments: "",
    loading: false,
    selectedProject: null,
    selectedService: null,
    payers: [],
    addProjectMenu: false,
    tab: "",
    payer: "",
    partnershipStoppedDate: null,
    partnershipStoppedReason: null,
    googleDriveFolders: [],
    url: "",
    email: "",
    crm: "",
  }),

  validations: {
    title: {
      required,
      minLength: minLength(3),
    },
    partnershipStopped: {
      required: requiredIf(function() {
        return this.partnershipStoppedCondition;
      }),
    },
    partnershipStoppedDate: {
      required: requiredIf(function() {
        return this.partnershipStoppedCondition;
      }),
    },
    partnershipStoppedReason: {
      required: requiredIf(function() {
        return this.partnershipStoppedCondition;
      }),
    },
    crm: {
      required,
    },
  },

  computed: {
    isNew() {
      return +this.id ? false : true;
    },
    header() {
      return this.isNew && !this.modal ? "Створення клієнта" : "Клієнт";
    },
    blockFormHeight() {
      return window.innerHeight - 144;
    },
    blockTabHeight() {
      return this.blockFormHeight - 240;
    },
    errors() {
      return {
        TITLE: [ERRORS.REQUIRED],
        PARTNERSHIP_STOPPED: [ERRORS.REQUIRED],
        PARTNERSHIP_STOPPED_DATE: [ERRORS.REQUIRED],
        PARTNERSHIP_STOPPED_REASON: [ERRORS.REQUIRED],
        CRM: [ERRORS.REQUIRED],
      };
    },
    partnershipStoppedCondition() {
      if (
        this.partnershipStopped &&
        (!this.partnershipStoppedDate || !this.partnershipStoppedReason)
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
  watch: {
    partnershipStopped: {
      handler(val) {
        if (val) {
          this.partnershipStoppedDate =
            this.partnershipStoppedDate || this.moment().format("YYYY-MM-DD");
        }
      },
    },
  },
  async created() {
    if (+this.id) {
      const requests = [
        clientsApi.getClient(this.id),
        clientsApi.getServices(this.id),
        clientsApi.getProducts(this.id),
      ];
      const [client, services, products] = await fetchInParallel(requests);

      this.title = client.title;
      this.partnershipStopped = client.partnershipStopped;
      this.comments = client.comments;
      this.manager = client.manager;
      this.analyst = client.analyst;
      this.updatesCabinetAccess = client.updatesCabinetAccess;
      this.projects = client.projects;
      this.payers = client.payers;
      this.partnershipStoppedReason = client.partnershipStoppedReason;
      this.partnershipStoppedDate = client.partnershipStoppedDate;
      this.googleDriveFolders = client.googleDriveFolders;
      this.services = services;
      this.products = products;
      this.url = client.url;
      this.email = client.email;
      this.crm = client.crm;
    }
  },
  methods: {
    async save() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      }

      this.loading = true;

      const client = {
        title: this.title,
        managerId: this.manager?.id ?? null,
        analystId: this.analyst?.id ?? null,
        projectIds: this.projects.map((p) => p.id),
        partnershipStopped: this.partnershipStopped,
        updatesCabinetAccess: this.updatesCabinetAccess,
        activatedServices: this.services.map((s) => {
          return {
            serviceId: s.service.id,
            startFrom: s.startFrom,
            payedTo: s.payedTo,
            stoppedFrom: s.stoppedFrom,
            price: s.price,
            writeOffWay: s.writeOffWay,
            quantity: s.quantity,
            stoppedReason: s.stoppedReason,
          };
        }),
        software: this.products.map((s) => {
          return {
            productId: s.product.id,
            regNumber: s.regNumber,
            updateByClient: s.updateByClient,
            version: s.version,
            notes: s.notes,
            invoiceId: s.invoice?.id || null,
            jiraIssueKey: s.jiraIssueKey || "null",
          };
        }),
        comments: this.comments,
        payerIds: this.payers.map((p) => p.id),
        partnershipStoppedReason: this.partnershipStoppedReason,
        partnershipStoppedDate: this.partnershipStoppedDate,
        googleDriveFolders: this.googleDriveFolders,
        email: this.email,
        url: this.url,
        crm: this.crm,
      };

      try {
        if (!this.isNew) {
          await clientsApi.updateClient(this.id, client);
        } else {
          await clientsApi.createClient(client);
        }
        this.$notifySuccess();
        this.$router.go(-1);
      } catch {
        this.$notifyWarning();
      } finally {
        this.loading = false;
      }
    },
    addProject(project) {
      this.projects.push(project);
    },
    calculateMultiplier(title) {
      return title
        .split("")
        .slice(0, 2)
        .join("");
    },
    addPayer(newPayer) {
      this.payers.push({
        id: newPayer.id,
        title: newPayer.title,
      });
    },
    redirectCRM(link) {
      if (link) {
        window.open(link, "_blank");
      }
    },
  },
};
</script>
